import { minutesOfDay } from "./assistanceTime";

export function localDateKey(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function shiftScheduleDate(date, days) {
  const value = new Date(`${date}T12:00:00`);
  value.setDate(value.getDate() + days);
  return localDateKey(value);
}
export function scheduleDates(date, view) {
  if (view === "day") return [date];
  const value = new Date(`${date}T12:00:00`);
  if (view === "month") value.setDate(1);
  const start = shiftScheduleDate(localDateKey(value), -((value.getDay() + 6) % 7));
  return Array.from({ length: view === "month" ? 42 : 7 }, (_, index) => shiftScheduleDate(start, index));
}
export function moveScheduleDate(date, view, direction) {
  if (view !== "month") return shiftScheduleDate(date, direction * (view === "day" ? 1 : 7));
  const value = new Date(`${date}T12:00:00`);
  const day = value.getDate();
  value.setDate(1);
  value.setMonth(value.getMonth() + direction);
  const lastDay = new Date(value.getFullYear(), value.getMonth() + 1, 0).getDate();
  value.setDate(Math.min(day, lastDay));
  return localDateKey(value);
}
export function scheduleEndMinutes(visit) {
  const start = minutesOfDay(visit.startTime);
  const end = minutesOfDay(visit.endTime);
  if (start === null || end === null || start === end) return null;
  return end < start ? end + 1440 : end;
}
export function scheduleDuration(visit) {
  const end = scheduleEndMinutes(visit);
  return end === null ? 0 : end - minutesOfDay(visit.startTime);
}
export function scheduleConflict(visits, candidate, excludeId) {
  const interval = (visit) => {
    const day = Date.parse(`${visit.date}T00:00:00Z`) / 60000;
    return [day + minutesOfDay(visit.startTime), day + scheduleEndMinutes(visit)];
  };
  const [start, end] = interval(candidate);
  return visits.find((visit) => {
    if (visit.id === excludeId || !(visit.employeeId === candidate.employeeId || (candidate.clientId && visit.clientId === candidate.clientId))) return false;
    const [otherStart, otherEnd] = interval(visit);
    return start < otherEnd && otherStart < end;
  });
}
export function layoutScheduleVisits(visits) {
  const sorted = [...visits].sort((a, b) => a.startTime.localeCompare(b.startTime) || a.endTime.localeCompare(b.endTime));
  const result = [];
  let cluster = [];
  let clusterEnd = -1;
  const flush = () => {
    const lanes = [];
    const placed = cluster.map((visit) => {
      const start = minutesOfDay(visit.startTime);
      let lane = lanes.findIndex((end) => end <= start);
      if (lane === -1) lane = lanes.length;
      lanes[lane] = scheduleEndMinutes(visit);
      return { ...visit, lane };
    });
    result.push(...placed.map((visit) => ({ ...visit, lanes: lanes.length })));
    cluster = [];
  };
  sorted.forEach((visit) => {
    const start = minutesOfDay(visit.startTime);
    const end = scheduleEndMinutes(visit);
    if (start === null || end === null || end <= start) return;
    if (start >= clusterEnd && cluster.length) flush();
    if (!cluster.length) clusterEnd = end;
    else clusterEnd = Math.max(clusterEnd, end);
    cluster.push(visit);
  });
  flush();
  return result;
}

export function unitScheduleTasks(unit, docs, clientId) {
  const groups = new Map(docs.filter((item) => item.kind === "clientGroup").map((group) => [group.id, group]));
  return docs.flatMap((item) => {
    const linkedClient = item.clientId || (item.groupId ? groups.get(item.groupId)?.clientId : unit?.clientId);
    if (linkedClient && linkedClient !== clientId) return [];
    if (item.kind === "clientGroup") return [];
    if (item.kind === "task") return [{ id: item.id, name: item.name, startTime: item.startTime, endTime: item.endTime }];
    return Object.entries(item.tasks || {}).map(([id, task]) => ({ id: `${item.id}/${id}`, name: task.text, startTime: task.startTime || task.time || item.startTime, endTime: task.endTime || item.endTime }));
  });
}
